var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.107,
    height: 36.243,
    viewBox: "0 0 32.107 36.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(-17.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11768",
    "data-name": "Path 11768",
    d: "M20.99,34.4A12.208,12.208,0,0,1,28.629,23.1l2.283-4.585a16.054,16.054,0,0,0-2.059,31.353l.439-3.907A12.211,12.211,0,0,1,20.99,34.4Z",
    transform: "translate(0 -16.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11769",
    "data-name": "Path 11769",
    d: "M182.749,37.56A16.082,16.082,0,0,0,171.027,22.1l-.449,3.9a12.189,12.189,0,0,1,.746,22.831l-2.346,4.615A16.078,16.078,0,0,0,182.749,37.56Z",
    transform: "translate(-133.516 -19.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11770",
    "data-name": "Path 11770",
    d: "M91.59,16.182a.893.893,0,0,0-.861-1.315H83.385L84.966,1.123A1.019,1.019,0,0,0,84.281.041.983.983,0,0,0,84,0a.964.964,0,0,0-.86.536L73.209,20.494a1.052,1.052,0,0,0,.043.982,1.026,1.026,0,0,0,.821.516h7.247L79.836,35.22a.916.916,0,0,0,.683.988.956.956,0,0,0,.277.035.966.966,0,0,0,.861-.529Z",
    transform: "translate(-49.222)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/Energy_icon.f04ed666f0d5999b26c6d349fcfd06e2.svg";
export { ForwardRef as ReactComponent };